import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// BootstrapVue Files
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import axios from 'axios'

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.config.productionTip = false

// URL CDN IMAGENES
Vue.prototype.$cdn = 'https://cdn.systemico.net/gogoals'
Vue.prototype.$cdnSystemico = 'https://cdn.systemico.net/systemico/'

if (process.env.NODE_ENV === 'production') {
  Vue.prototype.$url = '/'
  axios.defaults.baseURL = '/'
  Vue.prototype.$wsProducts = 'https://systemico.net/pay/products/'
  Vue.prototype.$productId = 1 // Llave de Wompi
} else {
  Vue.prototype.$url = 'http://localhost:8000/'
  axios.defaults.baseURL = 'http://localhost:8000/'
  Vue.prototype.$wsProducts = 'https://systemico.net/pay/products/'
  Vue.prototype.$productId = 1
}

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
